<div class="common-section-wrapper">
  <div class="common-container">
    <h3 class="common-section-title">{{ lg.goodsBlock.heading }}</h3>
    <div class="goods-block__list">
      @for (good of goods; track good) {
        <bmcore-good-item class="goods-block__item" [good]="good"></bmcore-good-item>
      }
    </div>
    <div class="common-btn-container">
      <bmcore-button title="{{ lg.button.showProducts }}" [routerPath]="'goods'" icon="btv-icon-btn-list">
      </bmcore-button>
    </div>
  </div>
</div>
